import {
  generateDrawerClasses,
  generateOverlayClasses,
} from './drawer.constants'

import type { DrawerProps } from './drawer.type'

export const Drawer = ({
  children,
  isOpen,
  onHandleOpen,
  size = 'default',
  className,
}: DrawerProps) => {
  const generatedOverlayClasses = generateOverlayClasses(
    isOpen ? 'open' : 'close',
  )

  const generatedMainClasses = generateDrawerClasses(
    isOpen ? 'open' : 'close',
    size,
    className,
  )

  return (
    <section>
      <div
        className={generatedOverlayClasses}
        onClick={() => onHandleOpen(false)}
      />
      <main className={generatedMainClasses}>{isOpen ? children : null}</main>
    </section>
  )
}
